<template>
  <div>
    <router-view />
  </div>
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
@import "assets/css/global.scss";
@import "assets/css/vuetify_custom.scss";
</style>

<script>
import { mapGetters, mapState } from "vuex";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, onSnapshot,addDoc, setDoc, query, where, deleteDoc, getDocs, orderBy, limit } from 'firebase/firestore';
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { messaging,analytics,db} from "@/config/firebaseConfig"
import { config } from "@/config/constants";

export default {
  name: "App",
  data: () => ({
    tokens: []
  }),
  computed: {
    ...mapState({
      user: (state) => state.Authenticate.user,
    }),
    ...mapGetters({
      isLoggin: "Authenticate/isLoggedIn"
    })
  },
  watch: {
    user(val) {
      if (val && val.id) {        
        this.registerToken(val.id);
      }
    },
    isLoggin: {
      handler(val) {
        if (val) {
          if (messaging && db) {
            this.listenToNotifications();
          } else {
            console.error("Firebase services are not initialized correctly.");
          }
        }
      },
      immediate: true
    }
  },
  /* mounted() {
    if (messaging && db) {
      this.listenToNotifications();
    } else {
      console.error("Firebase services are not initialized correctly.");
    }
  }, */
  methods: {
    async listenToNotifications() {
      try {
        const tokensCollectionRef = collection(db, "notifications");
        const latestNotificationQuery = query(tokensCollectionRef, orderBy("timestamp", "desc"), limit(1));
        onSnapshot(latestNotificationQuery, (snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added") {
              const notification = change.doc.data();
              this.loadNotification().then(() => {
                console.log("Notifications loaded");
              }).catch((error) => {
                console.error("Error loading notifications:", error);
              });
            }
          });
        });
      } catch (error) {
        console.error("Error:", error);
      }
    },
    async loadNotification() {
      try {
        await this.$store.dispatch(
          "Notifications_request_cms/getListAllNotifications",
          {
            notification: "enable",
            is_read: false,
            is_new: true,
            page: 1,
            limit: 10
          }
        );
        if (this.$route.name == "notifications_request_cms") {
          await this.$store.dispatch("Notifications_request_cms/getListAll");
        }
      } catch (error) {
        console.error("Error loading notifications:", error);
      }
    },
    async registerToken(userId) {
      try {
        const registration = await navigator.serviceWorker.register('../firebase-messaging-sw.js');
        console.log('Service Worker registered with scope:', registration.scope);
        const permission = await Notification.requestPermission();
        if (permission === 'granted') {
          const currentToken = await getToken(messaging, { vapidKey: config.vapidKey });
          if (currentToken) {
            const tokensQuery = collection(db, 'tokens');
            const querySnapshot = await getDocs(tokensQuery);
            const existingToken = querySnapshot.docs.find(doc => doc.data().token === currentToken && doc.data().userId === userId);
            if (existingToken) {
              await setDoc(existingToken.ref, { token: currentToken, userId: userId, timestamp: new Date() });
            } else {
              await addDoc(collection(db, 'tokens'), {
                token: currentToken,
                userId: userId,
                timestamp: new Date()
              });
            }
          } else {
            console.log('No registration token available.');
          }
        }  else if (permission === "denied") {
            console.log("You denied for the notification");
        }else {
          console.log('Unable to get permission to notify.');
        }
      } catch (error) {
        console.error('Error registering service worker or getting token:', error);
      }
    }
  }
};
</script>
